(() => {
  const closeDrawer = (button) => {
    const details = button.closest('header-drawer')?.querySelector(':scope > details');
    const summary = details?.querySelector(':scope > summary');
    if (!details?.open || !summary) return;
    summary.click();
    summary.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const closeButton = event.target.closest('[data-tohfa-drawer-close]');
    if (closeButton) closeDrawer(closeButton);
  });

  const setGlobalDrawer = (header, open) => {
    const drawer = header.querySelector('.tohfa-global-drawer');
    const motionHeader = header.querySelector('.tohfa-global-header');
    const toggle = header.querySelector('[data-tohfa-open]');
    header.classList.toggle('is-drawer-open', open);
    if (open) {
      motionHeader?.classList.remove('tohfa-header--hidden');
      motionHeader?.classList.add('tohfa-header--visible');
    }
    drawer?.classList.toggle('is-open', open);
    header.querySelector('.tohfa-drawer-overlay')?.classList.toggle('is-open', open);
    drawer?.setAttribute('aria-hidden', String(!open));
    toggle?.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('tohfa-drawer-open', open);
    if (open) header.querySelector('[data-tohfa-close]')?.focus({ preventScroll: true });
    else toggle?.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const header = event.target.closest('[data-tohfa-header]');
    if (header) {
      if (event.target.closest('[data-tohfa-open]')) setGlobalDrawer(header, true);
      if (event.target.closest('[data-tohfa-close]')) setGlobalDrawer(header, false);
    }
    document.querySelectorAll('.tohfa-language-dropdown[open]').forEach((dropdown) => {
      if (!dropdown.contains(event.target)) dropdown.removeAttribute('open');
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.tohfa-language-dropdown[open]').forEach((dropdown) => dropdown.removeAttribute('open'));
    const openHeader = document.querySelector('[data-tohfa-header].is-drawer-open');
    if (openHeader) setGlobalDrawer(openHeader, false);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth < 990) return;
    const openHeader = document.querySelector('[data-tohfa-header].is-drawer-open');
    if (openHeader) setGlobalDrawer(openHeader, false);
  }, { passive: true });

  document.addEventListener('shopify:section:unload', (event) => {
    if (event.target.querySelector?.('[data-tohfa-header].is-drawer-open')) {
      document.body.classList.remove('tohfa-drawer-open');
    }
  });

  const initHideOnScroll = (root = document) => {
    root.querySelectorAll('[data-tohfa-header][data-hide-on-scroll="true"]').forEach((header) => {
      if (header.dataset.scrollReady === 'true') return;
      header.dataset.scrollReady = 'true';
      let lastScrollY = Math.max(window.scrollY, 0);
      let ticking = false;
      const motionHeader = header.querySelector('.tohfa-global-header');

      const update = () => {
        const currentScrollY = Math.max(window.scrollY, 0);
        const delta = currentScrollY - lastScrollY;
        motionHeader?.classList.toggle('tohfa-header--scrolled', currentScrollY > 20);

        if (header.classList.contains('is-drawer-open') || currentScrollY < 80) {
          motionHeader?.classList.remove('tohfa-header--hidden');
          motionHeader?.classList.add('tohfa-header--visible');
        } else if (delta > 6) {
          motionHeader?.classList.add('tohfa-header--hidden');
          motionHeader?.classList.remove('tohfa-header--visible');
        } else if (delta < -6) {
          motionHeader?.classList.remove('tohfa-header--hidden');
          motionHeader?.classList.add('tohfa-header--visible');
        }

        lastScrollY = currentScrollY;
        ticking = false;
      };

      window.addEventListener('scroll', () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      }, { passive: true });
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initHideOnScroll());
  else initHideOnScroll();
  document.addEventListener('shopify:section:load', (event) => initHideOnScroll(event.target));
})();
